module.exports = __webpack_public_path__ + "static/media/hx.f9163be9.png";